var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenuBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m320.39 373.29c-16.695 0-30.23 13.535-30.23 30.23 0 16.695 13.535 30.23 30.23 30.23h559.23c16.695 0 30.23-13.535 30.23-30.23 0-16.695-13.535-30.23-30.23-30.23zm0 196.48c-16.695 0-30.23 13.535-30.23 30.23 0 16.695 13.535 30.23 30.23 30.23h559.23c16.695 0 30.23-13.535 30.23-30.23 0-16.695-13.535-30.23-30.23-30.23zm0 196.48c-16.695 0-30.23 13.535-30.23 30.23 0 16.695 13.535 30.23 30.23 30.23h559.23c16.695 0 30.23-13.535 30.23-30.23 0-16.695-13.535-30.23-30.23-30.23z",
    fill: "#c6dde2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBtn);
export default __webpack_public_path__ + "static/media/menuBtn.3a1809c0b179121a1207d829deaaf9e4.svg";
export { ForwardRef as ReactComponent };